export const PersianStrings = {
    settings: "تنظیمات",
    language: "زبان",
    theme: 'رنگ پوسته',
    light: 'روشن',
    dark: 'تیره',
    places: "مکان ها",
    updating: 'درحال بروزرسانی...',
    addingPlace: 'افزودن مکان',
    manual: 'افزودن دستی',
    receive: 'دریافت مکان',
    roomName: 'نام مکان:',
    add: 'افزودن',
    cancel: 'انصراف',
    fetchingReceiveCode: 'درحال دریافت کد',
    enterThisCodeToGetPlaces: 'برای دریافت مکان این کد را وارد کنید.',
    anErrorOccurredPleaseCheckInternetConnection: "خطایی رخ داده، از اتصالتان به اینترنت مطمئن شوید.",
    error: 'خطا',
    ok: 'تایید',
    pleaseEnterRoomName: 'لطفا نام مکان را وارد کنید.',
    pleaseEnterTargetUserCode: "لطفا کد کاربر مقصد را کامل وارد کنید.",
    selectedRoomsSentSuccessfully: "مکان های انتخاب شده با موفقیت ارسال شد.",
    userWithProvidedCodeDidNotFound:  "کاربری با این کد پیدا نشد.",
    receivePlace: 'دریافت مکان',
    logOut: 'خروج',
    update: 'بروزرسانی',
    anErrorOccurredWhileConnectingToDevicePleaseTryAgain: 'خطایی در اتصال با دستگاه ایجاد شده، لطفا دوباره امتحان کنید.',
    pleaseEnterRequestedInformations: 'لطفا اطلاعات درخواست شده را وارد کنید.',
    dataSusseccfullySentToDevicePleaseCloseAppAndConnectToInternet: 'اطلاعات با موفقیت برای دستگاه ارسال شد. نرم افزار را بسته و به اینترنت متصل شوید. ناپدید شدن شبکه ی zitco_config نشانه ی ثبت کامل دستگاه است.',
    anErrorOccurredPleaseEnsureThatYouAreConnectedToDeviceNetwork: 'خطایی رخ داده، از اتصال به شبکه دستگاه مطمئن شوید.',
    errorInSocketConnection: 'خطا در اتصال سوکت',
    deviceConfigurationIsNotPossibleWithWebApplication: 'ثبت دستگاه با نسخه وب امکان پذیر نمی باشد.',
    pleaseTurnOnLocationService: "لطفا روشن بودن موقعیت مکانی تان را چک کنید.",
    permissionDenied: "عدم دسترسی",
    plug: 'پریز',
    AC: 'تهویه',
    switch: 'کلید',
    connecting:'درحال اتصال...',
    addDevice: 'افزودن دستگاه',
    putDeviceOnConfigMode: 'ابتدا دستگاه را در حالت تنظیم قرار دهید.(چراغ روی دستگاه چشمک زن شود.)',
    nextStep: 'مرحله بعد',
    connectZITCOCONFIGThroughtWifi: 'از طریق وای فای به شبکه ZITCO_config متصل شوید.',
    password: '(رمز:123456789)',
    chooseNetworkAndEnterItsPassword: 'شبکه مورد نظر را انتخاب و پسورد آن را وارد کنید.',
    placeholderPassword: 'پسورد',
    chooseNetwork:  "انتخاب شبکه..." ,
    search: 'جستوجو',
    saveModemInfo:'اطلاعات مودم را ذخیره کن.',
    addingDevice: 'درحال افزودن دستگاه',
    addDevice: 'ثبت',
    edit: 'ویرایش',
    deny: 'لغو',
    save: 'ذخیره',
    signIn: 'ورود',
    enterYourPhoneNumber: 'شماره موبایل خود را وارد کنید.',
    phoneNumber: 'شماره موبایل:',
    sendCode: 'دریافت پیامک',
    serverInternalError: 'خطا داخلی سرور',
    textMessage: 'پیامک',
    activationWithTextMessage:'فعالسازی با پیامک',
    activationCode: 'کد فعالسازی:',
    activationCodeSuccessfullySentTo: 'کد فعالسازی با موفیقت ارسال شد به:',
    wrongCode: 'کد وارد شده، اشتباه است.',
    back: 'بازگشت',
    offlineConfig: 'فعالسازی کاربری آفلاین',
    home: 'خانه',
    senarios: 'سناریو ها',
    addSenario: 'افزودن سناریو',
    senarioName: 'نام سناریو',
    pleaseUseAnUsedName: "لطفا نام غیر تکراری انتخاب کنید.",
    pleaseChooseASenarioName: 'لظفا یک نام برای سناریو انتخاب کنید.',
    thisSenarioNameAlreadyUsed: 'این نام برای سناریو دیگری انتخاب شده است، لطفا نام غیرتکراری وارد کنید.',
    delete: 'حذف',
    share: 'اشتراک گذاری',
    offlineUsage: 'کاربری آفلاین',
    toUseOfflineUsageYouShouldEnableWifi: 'برای استفاده از حالت آفلاین باید شبکه وای فای روشن باشد. (شما میتوانید تنظیمات مربوط به کاربری آفلاین را در صفحه تنظیمات تغییر دهید.)',
    requestForWifiPermission: 'درخواست دسترسی به فای وای',
    ZitkitNeedsThisPermissionToConnectToYourSmartSwitch: 'زیت کیت برای اتصال خودکار به کلید هوشمند نیاز به این دسترسی دارد.',
    notNow: 'فعلا نه',
    notAllowed: 'مجاز نیست',
    Allowed: 'مجاز است',
    searchForOfflineModule: 'جست و جو',
    toYouOfflineUsageYouShouldTurnOfflineUsageOnInSettings: 'برای استفاده از حالت کاربری آفلاین باید کاربری آفلاین را در تنظیمات فعال کنید.',
    termsAndPolices: 'قوانین',
    readTermsAndPolicies: 'مطالعه قوانین و شرایط استفاده',

}